import { Button } from '~/components/common/button';
import { Translate, useTranslate } from '~/i18n';
import { BackArrowIcon } from '~/svgs/marketplace';

type WalletTermsType = {
   setTerms: (state: boolean) => void;
};

export const WalletTerms = ({ setTerms }: WalletTermsType) => {
   const { translate } = useTranslate();
   const condtions = [
      translate({ id: 'wallet:condition 1' }),
      translate({ id: 'wallet:condition 2' }),
      translate({ id: 'wallet:condition 3' }),
      translate({ id: 'wallet:condition 4' }),
      translate({ id: 'wallet:condition 5' }),
      translate({ id: 'wallet:condition 6' }),
   ];
   return (
      <div className="py-5 px-10 ">
         <Button
            onClick={() => setTerms(false)}
            theme="outline-secondary"
            className="!font-normal !px-5 flex items-center !border !border-grey-200">
            <span className="ltr:mr-3 rtl:ml-3 ">
               <BackArrowIcon width={18} height={18} className="rtl:rotate-180" />
            </span>{' '}
            <span className="hidden lg:block">
               <Translate id="common:back" />
            </span>
         </Button>
         <div className="flex flex-col gap-5">
            <h1 className="text-lg font-bold text-center">
               <Translate id="wallet:terms and conditions" />
            </h1>
            <hr />
            <p className="text-sm" dir="ltr">
               <Translate id="wallet:terms desclaimer" />
            </p>
            <ol className="list-decimal text-sm px-5" dir="ltr">
               {condtions?.map((condition, index) => (
                  <li className="py-2" key={index}>
                     {condition}
                  </li>
               ))}
            </ol>
         </div>
      </div>
   );
};
